/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, OnInit, OnDestroy, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { Helpers, User } from 'src/app/model';
import { FileSystemFileEntry, NgxFileDropEntry } from 'ngx-file-drop';
import { ImageCroppedEvent, ImageTransform, LoadedImage } from 'ngx-image-cropper';
import { ImageCropperModal } from '../image-cropper/image-cropper.modal';

@Component({
  selector: 'change-profile-photo-modal',
  templateUrl: './change-profile-photo.modal.html',
  styleUrls: ['./change-profile-photo.modal.scss']
})

export class ChangeProfilePhotoModal implements OnInit, OnDestroy {
  subject: Subject<boolean>;
  subscription: any;
  user: User = new User();
  path: string;
  files: File[] = [];
  imageBase64: string = "";
  imageType: string = "image/png";
  imageExt: string = ".png";
  imageMaxSize = 3000000;
  selectedImage: any = '';
  imageCropperModalRef: BsModalRef;
  showSizeError: boolean = false;

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    // Fix for when user clicks `ESC` instead of clicking, no Event was firing
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc')
        this.onCancel();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  onConfirm(): void {
    this.bsModalRef.hide();
    this.subject.next(this.selectedImage);
    this.subject.complete();
  }

  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next(null);
    this.subject.complete();
  }


  onSelect(event) {
    this.showSizeError = false;
    if (event.rejectedFiles.length > 0 && event.rejectedFiles[0].reason == "size") {
      this.showSizeError = true;
    }
    else if (event.addedFiles.length > 0) {
      const reader = new FileReader();
      reader.readAsDataURL(event.addedFiles[0]);
      reader.onload = () => {
        this.imageBase64 = reader.result as string;
        this.openImageCropperModal();
      }
    }
  }

  openImageCropperModal() {
    this.imageCropperModalRef = this.modalService.show(ImageCropperModal, Helpers.getModalConfig());
    const ackSubject = new Subject<boolean>();
    this.imageCropperModalRef.content.subject = ackSubject;
    this.imageCropperModalRef.content.imageBase64 = this.imageBase64;

    ackSubject.subscribe(value => {
      if (value) {
        this.selectedImage = value;
        this.onConfirm();
      }
    });
  }


  convertToBlob(uri, mime) {
    var byteString = atob(uri.split(',')[1]);
    var arrayBuffer = new ArrayBuffer(byteString.length);
    var intArray = new Uint8Array(arrayBuffer);
    for (var i = 0; i < byteString.length; i++) {
      intArray[i] = byteString.charCodeAt(i);
    }
    var blob = new Blob([arrayBuffer], { type: mime });
    return blob;

  }

  generateImageName() {
    return Math.random().toString(16).substring(2, 8 + 2);
  }


}
